import Nav from "../../general/nav.jsx";
import HeroFooter from "../../general/heroFooter.jsx";
import Imghero from "../../../assets/img/projects/JppCompta/JppCompta-Logo.svg";
import { useTranslation } from "react-i18next";

function Hero() {
  const { t } = useTranslation();

  return (
    <div className="JppCompta hero" id="hero">
      <Nav />
      <img className="ImgHero" src={Imghero} alt="JPP Compta Hero" />
      <HeroFooter
        name={t("jpp.hero.name")}
        link1url="https://jppcompta.fr/"
        link2display={false}
      />
    </div>
  );
}

export default Hero;
